import I18n from 'I18n';
import { PRICE_RATES_OBJECT } from 'customer-data-objects/product/PriceRates';
export function getMonthsPerPeriod(periodISOString) {
  if (!periodISOString) {
    return null;
  }
  const duration = I18n.moment.duration(periodISOString.toUpperCase());
  return duration.asMonths();
}
export function getPeriodFromMonths(months) {
  return months ? `P${months}M` : '';
}
export const getMonthsPerRatePeriod = rate => {
  const rateInfo = PRICE_RATES_OBJECT[rate];
  return rateInfo || 0;
};
export function doesBillingFrequencyEvenlyDividePeriod(period, billingFrequency) {
  if (!billingFrequency || !period) {
    return true;
  }
  const monthsPerFrequency = getMonthsPerRatePeriod(billingFrequency);
  const monthsPerTerm = getMonthsPerPeriod(period) || 0;
  return monthsPerTerm % monthsPerFrequency === 0;
}